import {ObjectIdentifierData} from "../basic/object-identifier-data";


export class MvsSearchFlexibleResultData {

    public objectData: ObjectIdentifierData;
    public label: string;

    public static create(objectData: ObjectIdentifierData, label: string) : MvsSearchFlexibleResultData {
        const resultData = new MvsSearchFlexibleResultData();
        resultData.objectData = objectData;
        resultData.label = label;
        return resultData;
    }

}
